import { Directive, signal } from '@angular/core';
import { BaseComponent } from '@ups/xplat/core';
import { HelpTypeEnum } from '../models';

@Directive()
export class HelpBaseComponent extends BaseComponent {
  public helpTypeEnum = HelpTypeEnum;

  public walkthroughIdValue: string;
  public walkthroughPathValue: string;

  // Signal so the injected help control (tooltip lightbulb) refreshes under
  // zoneless change detection — toggled from a store subscription that fires
  // outside any zone. Only the web HelpComponent extends this base.
  public showTooltips = signal(false);
}
